import { type ECommerceProduct } from '@hooks-api/types/dataModel/products'
import { type ProductMap } from '../types'

export const parseProductMap = (products?: ECommerceProduct[]): ProductMap | undefined => {
  return products?.reduce<ProductMap>((acc, product) => {
    acc[product.id] = product
    return acc
  }, {})
}
